__turbopack_context__.v({
  "backdrop": "dialog-module-scss-module__WWDohG__backdrop",
  "hidden": "dialog-module-scss-module__WWDohG__hidden",
  "popup": "dialog-module-scss-module__WWDohG__popup",
  "title": "dialog-module-scss-module__WWDohG__title",
});
